/** Дефолтное время за которое карта перемещаеться/миняет и т.д. зум */
export var DEFAULT_ANIMATION_DURATION = 300;

/**
 * Дефолтное количество объектов которые одновременно отрисовываются при загрузке пинов.
 * Остальные ставяться в очередь и рисуются не чаще чем раз в DEFAULT_GEO_OBJECTS_LOAD_DELAY
 *  */
export var DEFAULT_MAX_GEO_OBJECTS_PER_LOAD = 300;

/**  Дефолтное задержка, чаще которой новые геообъекты не рисуются  */
export var DEFAULT_GEO_OBJECTS_LOAD_DELAY = 500;

/**
 * Дефолтное размер кластаризатора в пикселях.
 * Все пины в ближе 200 пикселей к друг другу кластаризуются
 * */
export var DEFAULT_CLASTER_GRID_SIZE = 200;

/** Дефолтный цвет пинов если нет преданных пинов */
export var DEFAULT_CLASTER_ICON_COLOR = '#2b87db';

/** Дефолтная задержа при debounce */
export var DEFAULT_DEBOUNCE_DELAY = 100;

/** Дефолтная версия Yandex api */
export var DEFAULT_YANDEX_API_VERSION = '2.1.79';

/** Дефолтный url для запроса карт
 * параметр ключа к этому url должен добавляться из настройки firstPaintOptions.apiKey */
export var DEFAULT_DINAMIC_MAP_URL = 'https://enterprise.api-maps.yandex.ru/:version/?load=package.system&coordorder=longlat';

/**
 * Дефолтный коофицент влияющий на то, насколько большая зона будет во втором(четном) запросе за пинами.
 * Расчитывается по формуле k = fetchCoefficient * (currentZoom / minZoom)
 * */
export var DEFAULT_FETCH_COEFFICIENT = 1;

/** Дефолтный код языка карты */
export var DEFAULT_LANGUAGE = 'ru';

/** Дефолтный диапазон зума карты */
export var DEFAULT_ZOOM_RANGE = {
  min: 10,
  max: 17
};